import $ from 'jquery';

function loadShoppingBagCount(){
    if (window.rcProps && window.rcProps.showCartReminder) {
        showCartReminderPopup();
    }
    return new Promise((resolve, reject) => {
    $.ajax({
        type: 'GET',
        url: '/content/shoppingbag/getMinibagMarkup',
        success: function(data){
          resolve(data);
        },
        failure: function(){},
        error: function(error) {
          reject(error);
        }
    });
  });
}

function showCartReminderPopup() {
    $.ajax({
        type: 'GET',
        url: '/content/shoppingbag/reminderPopup',
        success: function(markup){
            if (markup.length > 0) {
                $('body').append('<div id="cart-reminder-popup"  class="modal"> </div>')
                $('#cart-reminder-popup').append(markup);
                $.modal({
                    triggerOpen: true,
                    open: 'cart-reminder-popup',
                    type: 'toast'
                });
                window.rcProps.showCartReminder = false;
            }
        }
    });
}

export default loadShoppingBagCount();


// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/header/load-shopping-bag-count.js